$(document).ready(function () {
  $(document).on("click", ".filter_apply_btn", function () {
    var url = $(this).data("url");
    var allFilters = "";
    var $activeFilters = $(".filter_checkbox:checked");
    var activeFiltersCount = $activeFilters.length;
    console.log(activeFiltersCount);
    if (activeFiltersCount == 0) {
      window.location = url;
    }
    var lastActiveFilterIndex = activeFiltersCount - 1;
    $activeFilters.each(function (index) {
      var filterValue = $(this).val(); // the tag
      allFilters += filterValue; // append the tag to our filters
      // To use multiple filters at once you must separate them with a + (plus)
      if (index !== lastActiveFilterIndex) {
        allFilters += "+";
      }
      var newUrl = url + "/tagged/" + allFilters;
      window.location = newUrl;
    });
  });

  $(document).on("click", ".filter_apply_btn_mobile", function () {
    var url = $(this).data("url");
    var allFilters = "";
    var $activeFilters = $(".filter_checkbox_mobile:checked");
    var activeFiltersCount = $activeFilters.length;
    console.log(activeFiltersCount);
    if (activeFiltersCount == 0) {
      window.location = url;
    }
    var lastActiveFilterIndex = activeFiltersCount - 1;
    $activeFilters.each(function (index) {
      var filterValue = $(this).val(); // the tag
      allFilters += filterValue; // append the tag to our filters
      // To use multiple filters at once you must separate them with a + (plus)
      if (index !== lastActiveFilterIndex) {
        allFilters += "+";
      }
      var newUrl = url + "/tagged/" + allFilters;
      window.location = newUrl;
    });
  });

  if ($(window).width() < 768) {
    $(document).on("click", ".footer-block--menu h2", function () {
      // $('.footer-block__details-content').removeClass('active');
      // $('.footer-block--menu h2').removeClass('active');
      if (
        $(this)
          .parent()
          .find(".footer-block__details-content")
          .hasClass("active")
      ) {
        $(this).removeClass("active");
        $(this)
          .parent()
          .find(".footer-block__details-content")
          .removeClass("active");
      } else {
        $(this).addClass("active");
        $(this)
          .parent()
          .find(".footer-block__details-content")
          .addClass("active");
      }
    });
  }
  $(".marquee-left").marquee({
    direction: "left",
    duration: 40000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true,
  });
  $(".marquee-right").marquee({
    direction: "right",
    duration: 40000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true,
  });

 
    $(".prod_media_slider").slick({
      dots: true,
      infinite: false,
      speed: 500,
      fade: true,
      arrows: false,
      cssEase: "linear",
    });
  

  $(".drawer-product-grid-new").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
  });

  // ======================start-tab-filter======================

  function slider() {
        
  if(!$(".block_only_slider-first").hasClass("slick-initialized")){

       $(".block_only_slider-first").slick({
      dots: false,
      infinite: false,
      centerMode: false,
      arrows: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

   
  }

  function Dailyroutine_filter_result() {
    var health_selected_val = "";
    var shopifyUrl;
    let collectionUrl;
    $(".category-group input.block_input-check:checked").each(function () {
      collectionUrl = $(this)
        .parents(".block_filter-collection")
        .attr("data-url");
      
      var current_val = $(this).attr("value").trim();
      if (current_val.indexOf("%") != -1) {
        current_val = current_val.replace("%", "%25");
      } else {
        current_val = current_val;
      }
      var final_val = current_val.replace(/ /g, "+");
      if (health_selected_val != "") {
        health_selected_val =
          health_selected_val + "&filter.p.tag=" + final_val;
      } else {
        health_selected_val = "&filter.p.tag=" + final_val;
      }
    });
    shopifyUrl = collectionUrl + "?" + health_selected_val;   
    $(".featured_slider").slick("unslick");
    $(".loading").show();
   $(".block_only_slider-first").css("display", "none");
    $(".block_not-found-text").css("display", "none");
    $.ajax({
      url: shopifyUrl,
      method: "GET",
      dataType: "html",
      success: function (data) {
        var productItems = $(data).find("#product-grid").html();
        var productItemsInner = $(data).find("#product-grid .grid__item");
        if (productItemsInner.length > 0) {
          $(".block_not-found-text").css("display", "none");
          $(".block_only_slider-first").html(productItemsInner);

          setTimeout(function () {  
          $(".block_only_slider-first").css("display", "block");   
          $(".loading").hide();  
            slider();
              $('.category-group input.block_input-check[type="checkbox"]').attr("disabled" , false)
          }, 1000);

          
        } else {
          $(".block_only_slider-first").html("");
          $(".block_not-found-text").css("display", "block");
            $(".loading").hide();
        }
      },
    });
  }

  $('.category-group input.block_input-check[type="checkbox"]').change(function (o) {
 $('.category-group input.block_input-check[type="checkbox"]').attr("disabled" , true)
    if ($(".category-group input.block_input-check:checked").length > 0) {
      o.preventDefault();
      $(".block_only_slider-first").show();
      $(".block_only_slider-secound").hide();
      Dailyroutine_filter_result();
    } else {
      $(".block_only_slider-first").hide();
      $(".block_only_slider-secound").show();
      $(".featured_slider").slick("refresh");
      $('.category-group input.block_input-check[type="checkbox"]').attr("disabled" , false)
    }
  });

  $(document).on("click", ".block_slider-reet-button", function () {
    $(".block__collection_tag_filter_inner input").prop('checked', false); 
     $(".block_only_slider-first").hide();
      $(".block_only_slider-secound").show();
      $(".featured_slider").slick("refresh");
  });

  // ======================end-tab-filter======================
  $(".mobile_review").slick({
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: "60px",
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "40px",
        },
      },
    ],
  });

  $(".main_suprise_box input:radio").change(function () {
    if ($(this).val() == "flavor box") {
      $(".surprice_box_property").attr("name", "properties[Flavor Box]");
      $(".flavor_box").removeAttr("disabled");
      $(".flavor_box").removeClass("disabled");
      $(".surprice_box_property").attr("value", "");
      $("#surprise-me-input").attr("value", "");
      $(".value_select").attr("disabled" , true)
    } else if ($(this).val() == "surprice_box") {
      $(".surprice_box_property").attr("name", "properties[Surprice Box]");
      $(".surprice_box_property").attr(
        "value",
        "Our best flavors picked out for you"
      );
      $(".flavor_box").attr("disabled", "true");
      $(".flavor_box").addClass("disabled");
      $("#select-flavor-box-input").attr("value", "");
      $("#surprise-me-input").attr(
        "value",
        "Our best flavors picked out for you"
      );
      $(this)
        .parents(".product__info-wrapper")
        .find(".product-form__submit")
        .prop("disabled", false);
      $(this).parents(".product__info-wrapper").find(".block_opions").hide();
          $(".value_select").attr("disabled" , false)
    }
  });
  $(".main_suprise_box .flavor_box").on("change", function () {
    var selected_val = this.value;
    if (selected_val != "") {
      $(".surprice_box_property").attr("value", selected_val);
      $("#select-flavor-box-input").attr("value", selected_val);
      $(this)
        .parents(".product__info-wrapper")
        .find(".product-form__submit")
        .prop("disabled", false);
      $(this).parents(".product__info-wrapper").find(".block_opions").hide();
      $(".block_flavor-box-copy-select").find(`.option-button input[value="${selected_val}"]`).trigger("click");      
    } else {
      $(".surprice_box_property").attr("value", "");
      $("#select-flavor-box-input").attr("value", "");
      $(this)
        .parents(".product__info-wrapper")
        .find(".product-form__submit")
        .prop("disabled", true);
      $(this).parents(".product__info-wrapper").find(".block_opions").show();
      $(".block_flavor-box-copy-select").find(`.block_flavor-box-copy-select-first input`).trigger("click");

        $(".prod_media_slider").slick('slickGoTo', parseInt(0))
    }
  });
  $(document).on("click", ".block_suprise-box", function () {
    var selected_val = $(".flavor_box").val();
    var $boxBtn = $(this).parents(".product__info-wrapper").find(".flavor_box");

    if ($(".main_suprise_box #surprice_box").is(":checked")) {
      $(this).parents(".product__info-wrapper").find(".product-form__submit").prop("disabled", false);
      $(this).parents(".product__info-wrapper").find(".block_opions").hide();
    } else {

      if (selected_val != "") {
        $(this)
          .parents(".product__info-wrapper")
          .find(".product-form__submit")
          .prop("disabled", false);
        $(this).parents(".product__info-wrapper").find(".block_opions").hide();
      } else {
        $(this)
          .parents(".product__info-wrapper")
          .find(".product-form__submit")
          .prop("disabled", true);
        $(this).parents(".product__info-wrapper").find(".block_opions").show();
      }
    }
  });

  $(document).on("click", ".qtyplus", function (e) {
    e.preventDefault();
    fieldName = $(this).attr("field");
    var currentVal = parseInt(
      $(this)
        .parent()
        .find("input[name=" + fieldName + "]")
        .val()
    );
    if (!isNaN(currentVal)) {
      $(this)
        .parent()
        .find("input[name=" + fieldName + "]")
        .val(currentVal + 1);
    } else {
      $(this)
        .parent()
        .find("input[name=" + fieldName + "]")
        .val(1);
    }
  });
  $(document).on("click", ".qtyminus", function (e) {
    e.preventDefault();
    fieldName = $(this).attr("field");
    var currentVal = parseInt(
      $(this)
        .parent()
        .find("input[name=" + fieldName + "]")
        .val()
    );
    if (!isNaN(currentVal) && currentVal > 1) {
      $(this)
        .parent()
        .find("input[name=" + fieldName + "]")
        .val(currentVal - 1);
    } else {
      $(this)
        .parent()
        .find("input[name=" + fieldName + "]")
        .val(1);
    }
  });
});
//Card Product subscription Js

$(document).ready(function () {
  $(document).on("click", ".subscribe_product", function () {
    if (!$(this).is(":checked")) {
      $(this).parent().parent().removeClass("active_subscription");
      $(this).parents(".grid__item").find(".block_selling_plan_id").val("");
    } else {
      $(this).parent().parent().addClass("active_subscription");
      let firstId = $(this)
        .parents(".grid__item")
        .find(".selling_plan_dropdown:first-child")
        .val();
      $(this)
        .parents(".grid__item")
        .find(".block_selling_plan_id")
        .val(firstId);
    }
  });
});

// Account Js
$(document).ready(function () {
  $(".subscription-links .tab-link").on("click", function () {
    var tab = $(this).data("tab");
    $(".subscription-links .tab-link").removeClass("active");
    $(this).addClass("active");

    $(".subscription-tab-container .tab-content").removeClass("active");
    $(".subscription-tab-container .tab-content#" + tab).addClass("active");
    //$("html").animate({ scrollTop: 0 }, "slow");
  });

  var hash = window.location.hash;
  if (hash != "") {
    $(".account-sidebar li").removeClass("active");
    $('[data-tab="' + hash + '"]')
      .parent("li")
      .addClass("active");

    $(".account-tabs .account-tab").removeClass("active");
    $(hash).addClass("active");
  }

  $(".account-sidebar a.account-links").on("click", function (e) {
    e.preventDefault();
    var hash = $(this).data("tab");

    if (hash != undefined) {
      var url = window.location.href;
      console.log(url);
      console.log(url.indexOf("#"));
      if (url.indexOf("#") != -1) {
        var arr = url.split("#");
        window.location.href = arr[0] + hash;
      } else {
        window.location.href = url + hash;
      }

      $(".account-sidebar li").removeClass("active");
      $('[data-tab="' + hash + '"]')
        .parent("li")
        .addClass("active");

      $(".account-tabs .account-tab").removeClass("active");
      $(hash).addClass("active");
      $("html").animate(
        {
          scrollTop: 0,
        },
        "slow"
      );
    } else {
      var url = window.location.href;
      window.location.href = url.replace(window.location.hash, "");

      $(".account-sidebar li").removeClass("active");
      $(".account-sidebar-nav li:first").addClass("active");

      $(".account-tabs .account-tab").removeClass("active");
      $(".account-tabs .account-tab:first").addClass("active");
      $("html").animate(
        {
          scrollTop: 0,
        },
        "slow"
      );
    }
  });
  $(document).on("click", ".address_edit_btn", function () {
    var form_id = $(this).attr("aria-controls");
    if ($(".adress_form_block .edit_address").hasClass("active")) {
      $(".adress_form_block .edit_address").removeClass("active");
    } else {
      $(".adress_form_block #" + form_id).addClass("active");
      $(".adress_form_block #AddAddress").removeClass("active");
    }
  });
  $(document).on("click", ".add_address_box", function () {
    if ($(".adress_form_block #AddAddress").hasClass("active")) {
      $(".adress_form_block #AddAddress").removeClass("active");
    } else {
      $(".adress_form_block #AddAddress").addClass("active");
      $(".adress_form_block .edit_address").removeClass("active");
    }
  });
});

// Mobile Toggle Blog and Account
$(document).ready(function () {
  $(".filter_mobile .filter_title").click(function () {
    $(".filter_hide").toggleClass("show_filter");
  });
  $(".sidebar_mobile .open_short_by").click(function () {
    $(".dashboard-leftsec").toggleClass("show_filter");
  });

  let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });
});

$(".product_option .swatch_button").hide();
$(".product_option").find(".swatch_button:lt(4)").show();

$(document).on("click", ".js-load-more", function () {
  var $this = $(this),
    totalPages = parseInt($("[data-all-pages]").val()),
    currentPage = parseInt($("[data-this-page]").val()),
    datacollurl = $("[data-coll-url]").val();
  $this.attr("disabled", true);
  $this.html("<span load-more-text>Loading...</span>");
  setTimeout(function () {
    $this.addClass("loading_btn");
  }, 200);
  setTimeout(function () {
    $this.find("[load-more-text]").addClass("hide");
    $this.find("[loader]").removeClass("hide");
    var nextUrl = $("[data-next-link]").val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    //alert(current_page_new)
    //return false;
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        $("[data-next-link]").val(datacollurl + "page=" + next_coll);
        $("[data-this-page]").val(current_page_new);
        $("#blog_list").append($(responseHTML).find("#blog_list").html());
        $("#product-grid").append($(responseHTML).find("#product-grid").html());
        setTimeout(function () {
          $("#blog_list").find(".load-more_wrap").remove();
        }, 100);
      },
      complete: function () {
        if (current_page_new < totalPages) {
          $this.removeClass("loading_btn");
          $this.html("<span load-more-text>Load more</span>");
          $this.attr("disabled", false);
          $this.find("[load-more-text]").removeClass("hide");
          $this.find("[loader]").addClass("hide");
        }
        if (current_page_new >= totalPages) {
          //$this.find('[load-more-text]').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
          $this.find("[load-more-text]").parents(".load-more_wrap").hide();
        }
      },
    });
  }, 1000);
});

// cartAddData();
